import React from "react";

//React hooks
import { useState, useEffect, useContext, useRef } from "react";

//MUI Components 
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Tabs,
  Tab,
  Tooltip,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Menu,
  MenuItem,
  Stack,
  Modal,
  IconButton,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

//MUI Icons
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import CloseIcon from "@mui/icons-material/Close";


//Custom Components
import CommonAccordion from "../../custom-components/CommonAccordion";
import CommonDownload from "../../custom-components/CommonDownload";
import SecurityTestPlan from "./SecurityTestPlan";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { securityPlan } from "../../../services/webServices";
import RenderTableDataInPDF from "../../../utils/RenderTableDataInPDF";
import CommonCopy from "../../custom-components/CommonCopy";
import { ReactComponent as DeleteIcon } from "../../../images/SecurityDeleteIcon.svg";
import CommonEditDialog from "../../popup-components/CommonEditPopup";
import CommonEditableTable from "../../custom-components/EditableTableForDocuments";
import { SecurityFlowDataContext } from "../../main-pages/SecurityTestingPage";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";


const SecondFunctionalModules = () => {

  //useContext
  const { funcMod, securityReq } = useContext(SecurityFlowDataContext);
  const { setLoadingState } = useContext(LoadingModalContext);

  //Navigation and Routing
  const navigate = useNavigate();
  const location = useLocation();

  //Design phase outputs from state
  const securityRecommendationsFromState = location.state?.securityRecommendations;
  const threatModellingFromState = location.state?.threatModelling;
  const addReviewFromState = location.state?.addReview;
  const securityTestPlanFromState = location.state?.securityTestPlan;
  const funcModFromstate = location.state?.funcMod;
  const securityReqFromState = location.state?.securityReq;

  //State Variables for updated output values
  const [securityRecommendationsData, setSecurityRecommendationsData] = useState([]);
  const [threatModellingData, setThreatModellingData] = useState([]);
  const [addReviewData, setAddReviewData] = useState([]);
  const [addReview, setAddReview] = useState({});
  const [securityTestPlanData, setSecurityTestPlanData] = useState([]);

  const [testPlanInput, setTestPlanInput] = useState(null);

  //State variables for Data Flow Diagram
  const [pngData, setPngData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  //State Variables for Edit functionality - SR, ADR, TM-Description
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [anchorE3, setAnchorE3] = useState(null);
  const [openSecRecomEdit, setOpenSecRecomEdit] = useState(false);
  const [openADDReviewEdit, setOpenADDReviewEdit] = useState(false);
  const [openTMDescEdit, setOpenTMDescEdit] = useState(false);
  const [selectedSecRecom, setSelectedSecRecom] = useState(null);
  const [selectedADDReview, setSelectedADDReview] = useState(null);
  const [selectedSecRecomIndex, setSelectedSecRecomIndex] = useState(null);
  const [selectedADDReviewIndex, setSelectedADDReviewIndex] = useState(null);


  //State Variable for Edit functionality - Threat Modelling Description
  const [descriptionText, setDescriptionText] = useState(threatModellingData?.parsedThreatModelling?.["Description"] || "");

  //State Variables for Edit functionality - Threat Modelling Tables
  const [tableEditState, setTableEditState] = useState({});
  const [tableVisibility, setTableVisibility] = useState({});
  const [menuAnchorElMap, setMenuAnchorElMap] = useState({});

  //State Variables for Download
  const [downloadEachTabData, setDownloadEachTabData] = useState(null);
  const [downloadETDOpen, setDownloadETDOpen] = useState(false);
  const [downloadOpen, setDownloadOpen] = useState(false);

  //SAST Variables for Test Plan questionnaire
  const [linesOfCode, setLinesOfCode] = useState("");
  const [languagesUsed, setLanguagesUsed] = useState("");
  const [thirdPartyUsed, setThirdPartyUsed] = useState("");

  //DAST Variables for Test Plan questionnaire
  const [appURL, setAppURL] = useState("");
  const [technologyStack, setTechnologyStack] = useState("");
  const [noOfUsers, setNoOfUsers] = useState("");
  const [userRoles, setUserRoles] = useState("");
  const [multiFactorAuth, setMultiFactorAuth] = useState("");
  const [urlError, setUrlError] = useState(false);
  const [touched, setTouched] = useState(false);

  //Additional Variables for Test Plan questionnaire
  const [clientName, setClientName] = useState("");
  const [appName, setAppName] = useState("");
  const [testPlanResponse, setTestPlanResponse] = useState({});
  const [showErrors, setShowErrors] = useState(false);

  //Other state variables
  const [tabValue, setTabValue] = useState(0);
  const [activeThumb, setActiveThumb] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  const hrForPdf = "_".repeat(68);
  const hrForDoc = "_".repeat(98);


  //Scrolling reference
  const scrollRef = useRef(null);
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [tabValue]);


  //Transforming function for ouputs (col- row)
  const transformData = (dataFromState) => {
    if (
      dataFromState &&
      typeof dataFromState === "object" &&
      dataFromState !== null
    ) {
      const keys = Object.keys(dataFromState);
      if (keys.length > 0) {
        const itemCount = dataFromState[keys[0]]?.length || 0;
        return Array.from({ length: itemCount }, (_, index) => {
          const item = {};
          keys.forEach((key) => {
            item[key] = dataFromState[key]?.[index];
          });
          return item;
        }).filter((item) =>
          Object.values(item).some((value) => value !== undefined)
        );
      }
    }
    return [];
  };

  //Update ouput values - SR,ADR,STP
  useEffect(() => {
    setSecurityRecommendationsData(transformData(securityRecommendationsFromState));
    setAddReviewData(transformData(addReviewFromState));
    setSecurityTestPlanData(transformData(securityTestPlanFromState));
  }, [
    securityRecommendationsFromState,
    addReviewFromState,
    securityTestPlanFromState,
  ]);
  useEffect(() => {
    setAddReview(addReviewFromState ? { ...addReviewFromState } : {});
  }, [addReviewFromState]);


  //Update Threat Modelling output
  useEffect(() => {
    if (threatModellingFromState) {
      setThreatModellingData(threatModellingFromState);
    }
  }, [threatModellingFromState]);

  useEffect(() => {
    const convertAndSet = async () => {
      if (threatModellingData?.flowchartResponse) {
        const imageData = await svgToPngBase64(threatModellingData.flowchartResponse);
        setPngData(imageData);
      }
    };
    convertAndSet();
  }, [threatModellingData]);


  //Formatting Security Recommendations for Word and Pdf
  const secRecommendationsToDownload = securityRecommendationsData.map((item) => {
    const rawRecs = Array.isArray(item["Security Recommendations"])
      ? item["Security Recommendations"].join("\n")
      : String(item["Security Recommendations"] || "");
    const recsArray = rawRecs
      .split(/^\s*-\s+|\n\s*-\s+/g)
      .map(rec => rec.trim())
      .filter(rec => rec.length > 0);
    const formattedRecommendations = recsArray
      .map(rec => `• ${rec}`)
      .join("\n");
    return {
      heading: item["Module Name"],
      type: "text",
      data: formattedRecommendations,
    };
  });



  //Formatting Architecture Design Review for Word and Pdf
  const addReviewToDownload = Object.entries(addReview || {}).map(
    ([category, dataArray]) => ({
      heading: category,
      type: "text",
      data: Array.isArray(dataArray)
        ? dataArray.map((item) => `• ${item}`).join("\n")
        : "",
    })
  );


  //Formatting Threat Modelling for Word and Pdf
  const threatModellingWithoutDFD =
    threatModellingData.parsedThreatModelling &&
      Object.keys(threatModellingData.parsedThreatModelling).length > 0
      ? threatModellingData.parsedThreatModelling
      : null;
  const threatTableNames = [
    "External Dependencies Table",
    "Entry Points Table",
    "Assets Table",
    "Trust Levels Table",
    "STRIDE Threat List",
    "Threats Identified Table"
  ];
  const threatModelToDownload = [
    {
      heading: "Description",
      type: "text",
      data: threatModellingWithoutDFD?.Description || "N/A",
    },
    ...threatTableNames.map(title => ({
      heading: title,
      type: "table",
      data: threatModellingWithoutDFD
        ? RenderTableDataInPDF(threatModellingWithoutDFD, title)
        : ""
    }))
  ];


  //svg to png conversion for Data flow diagram
  const svgToPngBase64 = (svgString) => {
    return new Promise((resolve, reject) => {
      const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(svgBlob);
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const pngBase64 = canvas.toDataURL("image/png");
        resolve(pngBase64);

        URL.revokeObjectURL(url);
      };
      img.onerror = reject;
      img.src = url;
    });
  };


  //Formatting table data for Copy functionality
  const formatThreatModellingDataReadable = (dataArray) => {
    return dataArray.map(item => {
      if (item.type === 'text') {
        return `Heading: ${item.heading}\nType: ${item.type}\nData: ${item.data}`;
      } else if (item.type === 'table') {
        const headers = item.data.headers;
        const values = item.data.values;

        const formattedRows = values.map(row => {
          return headers.map((header, idx) => `${header}: ${row[idx]}`).join('\n');
        }).join('\n---\n');
        return `Heading: ${item.heading}\nType: ${item.type}\nData:\n${formattedRows}`;
      } else {
        return `Heading: ${item.heading}\nType: ${item.type}\nData: Unsupported format`;
      }
    }).join('\n\n');
  };


  //Handling functions for 'Download' and 'Download All'
  const handleDownload = () => {
    setDownloadOpen(true);
  };
  const handleEachTabDownload = () => {
    let serviceResponse = {};
    let wordData = {};
    let serviceName = "";

    switch (tabValue) {
      case 0:
        serviceName = "Security Recommendations Document"
        serviceResponse = [...secRecommendationsToDownload]
        wordData = [...secRecommendationsToDownload];
        break;
      case 1:
        serviceName = "Threat Modelling Document";
        serviceResponse = [
          ...threatModelToDownload,
          {
            heading: "Data Flow Diagram",
            type: "image",
            data: pngData
          },
        ]
        wordData = [
          ...threatModelToDownload,
          {
            heading: "Data Flow Diagram",
            type: "image",
            data: pngData?.replace(/^data:image\/png;base64,/, "") || ""

          },
        ]
        break;
      case 2:
        serviceName = "Architecture Design Review Document";
        serviceResponse = [...addReviewToDownload];
        wordData = [...addReviewToDownload];
        break;
      default:
        return;
    }
    setDownloadEachTabData({
      serviceName,
      serviceResponse,
      wordData,
    });

    setDownloadETDOpen(true);
  };


  //Security  Recommendations - Edit Functionality
  const handleSecRecomMenuClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedSecRecom(securityRecommendationsData[index]);
  };
  const handleSecRecomMenuClose = () => {
    setAnchorEl(null);
    setSelectedSecRecomIndex(null);
  };
  const handleSecRecomEdit = (item) => {
    setSelectedSecRecom(transformSecRecomForEdit(item));
    setOpenSecRecomEdit(true);
  };
  const transformSecRecomForEdit = (item) => {
    let raw = Array.isArray(item["Security Recommendations"])
      ? item["Security Recommendations"].join("\n")
      : item["Security Recommendations"] || "";

    const formatted = raw
      .split("\n")
      .map((line) => {
        return line.trim().replace(/^[-•*]\s*/, "");
      })
      .join("\n");
    return {
      title: item["Module Name"] || "",
      recommendations: formatted,
      sNo: item["S.No"],
    };
  };
  const handleSecRecomSave = (updatedItem) => {
    setSecurityRecommendationsData((prevData) =>
      prevData.map((rec) =>
        rec["S.No"] === updatedItem.sNo
          ? {
            ...rec,
            "Module Name": updatedItem.title,
            "Security Recommendations": updatedItem.recommendations,
          }
          : rec
      )
    );
    setOpenSecRecomEdit(false);
  };
  const handleSecRecomDelete = (itemId) => {
    const updatedData = securityRecommendationsData.filter((d) => d["S.No"] !== itemId);
    setSecurityRecommendationsData(updatedData);
  };


  // Architecture Design Review  - Edit Functionality
  const handleADDReviewMenuClick = (event, field, value, index) => {
    setAnchorE2(event.currentTarget);
    setSelectedADDReview({ field, value, index });
  };


  const handleADDReviewMenuClose = () => {
    setAnchorE2(null);
    setSelectedADDReviewIndex(null);
  };
  const handleADDReviewEdit = (moduleIndex, field, pointIndex, newValue) => {
    setAddReviewData((prevData) =>
      prevData.map((module, i) => {
        if (i === moduleIndex) {
          return {
            ...module,
            [field]: module[field].map((item, idx) =>
              idx === pointIndex ? newValue : item
            )
          };
        }
        return module;
      })
    );
  };
  const handleADDReviewSave = (updatedItem) => {
    const { field } = selectedADDReview;
    if (!field) return;

    const newValues = updatedItem.value
      .split("\n")
      .map(line => line.trim())
      .filter(Boolean);

    setAddReview(prev => ({ ...prev, [field]: newValues }));
    setOpenADDReviewEdit(false);
  };

  const handleADDReviewDelete = (_index, field) => {
    setAddReview(prev => {
      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  //Threat Modelling Description - Edit Functionality
  const handleTMDescMenuClick = (event) => {
    setAnchorE3(event.currentTarget);
  };
  const handleTMDescMenuClose = () => {
    setAnchorE3(null);
  };
  const handleTMDescEdit = () => {
    setOpenTMDescEdit(true);
    handleTMDescMenuClose();
  };
  const transformTMDescForEdit = (desc) => {
    const formatted = desc
      .split("\n")
      .map((line) => line.trim().replace(/^[-•*]\s*/, ""))
      .join("\n");
    return formatted;
  };
  const handleTMDescSave = (updatedDesc) => {
    setThreatModellingData((prev) => ({
      ...prev,
      parsedThreatModelling: {
        ...prev.parsedThreatModelling,
        Description: updatedDesc,
      },
    }));
    setDescriptionText(updatedDesc);
    setOpenTMDescEdit(false);
  };
  const handleTMDescDelete = () => {
    setThreatModellingData((prev) => ({
      ...prev,
      parsedThreatModelling: {
        ...prev.parsedThreatModelling,
        Description: "",
      },
    }));
    setDescriptionText("");
    setOpenTMDescEdit(false);
    handleTMDescMenuClose();
  };


  // Table handlers - threat modelling
  const handleTableMenuClick = (event, tableName) => {
    setMenuAnchorElMap((prev) => ({
      ...prev,
      [tableName]: event.currentTarget,
    }));
  };
  const handleTableMenuClose = (tableName) => {
    setMenuAnchorElMap((prev) => ({
      ...prev,
      [tableName]: null,
    }));
  };
  const handleTableEdit = (tableName) => {
    setTableEditState((prev) => ({
      ...prev,
      [tableName]: true,
    }));
    handleTableMenuClose(tableName);
  };
  const handleTableDelete = (tableName) => {
    setTableVisibility((prev) => ({
      ...prev,
      [tableName]: false,
    }));
    handleTableMenuClose(tableName);
  };

  const handleTableSave = (tableName) => {
    setTableEditState((prev) => ({
      ...prev,
      [tableName]: false,
    }));
  };
  const handleTableCancel = (tableName) => {
    setTableEditState((prev) => ({
      ...prev,
      [tableName]: false,
    }));
  };


  //Button enable conditions
  const isSubmitButtonDisabled = !(
    linesOfCode.trim() ||
    languagesUsed.trim() ||
    thirdPartyUsed.trim() ||
    appURL.trim() ||
    technologyStack.trim() ||
    noOfUsers.trim() ||
    userRoles.trim() ||
    multiFactorAuth.trim() ||
    clientName.trim() ||
    appName.trim()
  );

  //URL validation
  const validateURL = (url) => {
    const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/;
    return urlPattern.test(url);
  };

  //like and dislike
  const handleThumbClick = (thumbType) => {
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };

  //Modal open, close
  const handleOpen = () => {
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
  };


  //Image Download
  const handleDownloadImage = () => {
    const flowchartImage = threatModellingData?.flowchartResponse;
    if (flowchartImage) {
      const link = document.createElement("a");
      link.href = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(flowchartImage)}`;
      link.download = "data flow diagram.svg";
      link.click();
    }
  };


  //Navigation to SAST
  const handleConstructionPhase = async () => {
    try {
      navigate("/dashboard/security-testing/construction-phase");
    } catch (error) {
      console.error("Error During Navigation:", error);
    }
  };



  const handleSecurityTestPlan = async () => {
    if (
      !clientName.trim() ||
      !linesOfCode.trim() ||
      !appName.trim() ||
      !appURL.trim()
    ) {
      setShowErrors(true);
      return;
    }
    if (!validateURL(appURL)) {
      setShowErrors(true);
      setUrlError(true);
      return;
    }
    const inputData = {
      clientName,
      appName,
      appURL
    };

    let progressHandler;
    try {
      progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 35000 });
      progressHandler.start("Generating Security Test Plan");
      const securityTestPlanResponse = await securityPlan({
        formData:inputData,
        funcMod: funcModFromstate,
        securityReq: securityReqFromState,
        securityRecom: securityRecommendationsData,
        threatM: threatModellingData.parsedThreatModelling,
      });
      const securityTestPlan = securityTestPlanResponse.data;

      setTestPlanResponse(securityTestPlan);
      setTestPlanInput(inputData);
      await progressHandler.finishAndClose();

    } catch (error) {
      console.error("Error during design phase:", error);
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      if (progressHandler) {
        progressHandler.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
  };


  //Rendering function for each tab
  const renderContent = (data) => {
    return (
      <Box sx={{ padding: 1 }}>
        {/* rendering for Tab 0 (Security Recommendations) */}
        {tabValue === 0 ? (
          <Box sx={{ padding: 1 }}>
            {securityRecommendationsData.map((req, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  p: 2,
                  backgroundColor: "#7E83880F",
                  borderRadius: 1,
                }}
              >   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", ml: 1 }}>
                  <Typography variant="subtitle2" fontWeight={550}>
                    {req["Module Name"]}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={(e) => handleSecRecomMenuClick(e, index)}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </Box>

                {Array.isArray(req["Security Recommendations"]) ? (
                  req["Security Recommendations"].map((recommendation, recIndex) => {
                    const recommendationStr = String(recommendation).trim();
                    const recommendationText = recommendationStr.startsWith("- ")
                      ? recommendationStr.substring(2).trim()
                      : recommendationStr;
                    return (
                      <Typography
                        key={recIndex}
                        variant="body2"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "0.5rem",
                          }}
                        >
                          <ArrowRightIcon fontSize="small" />
                          <span>{recommendationText}</span>
                        </li>
                      </Typography>

                    );
                  })
                ) : typeof req["Security Recommendations"] === "string" ? (
                  req["Security Recommendations"]
                    .split("\n")
                    .map((recommendation, recIndex) => {
                      const recommendationStr = String(recommendation).trim();
                      const recommendationText = recommendationStr.startsWith("- ")
                        ? recommendationStr.substring(2).trim()
                        : recommendationStr;
                      return (
                        <Typography
                          key={recIndex}
                          variant="body2"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "0.5rem",
                            }}
                          >
                            <ArrowRightIcon fontSize="small" />
                            <span>{recommendationText}</span>
                          </li>
                        </Typography>
                      );
                    })
                ) : (
                  <Typography variant="body2" color="error">
                    Error: Security Requirements are in an unexpected format.
                  </Typography>
                )}
              </Box>
            ))}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleSecRecomMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  handleSecRecomEdit(selectedSecRecom);
                  handleSecRecomMenuClose();
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <EditOutlinedIcon color="primary" />
                  <span>Edit</span>
                </Stack>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  handleSecRecomDelete(selectedSecRecom?.["S.No"]);
                  handleSecRecomMenuClose();
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <DeleteIcon color="error" />
                  <span>Delete</span>
                </Stack>
              </MenuItem>

            </Menu>
          </Box>
        ) : tabValue === 1 ? (
          // rendering for Tab 1 (Threat Modelling)
          <Box sx={{ padding: 1 }}>
            {threatModellingData ? (
              <>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{}}>
                  <Typography variant="body2" fontWeight="bold">
                    Description
                  </Typography>
                  <IconButton onClick={(e) => handleTMDescMenuClick(e)}>
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Typography variant="body2">
                  {threatModellingData?.parsedThreatModelling?.["Description"]}
                </Typography>
                <Menu
                  anchorEl={anchorE3}
                  open={Boolean(anchorE3)}
                  onClose={handleTMDescMenuClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem
                    onClick={() => {
                      handleTMDescEdit();
                      handleTMDescMenuClose();
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <EditOutlinedIcon color="primary" />
                      <span>Edit</span>
                    </Stack>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      handleTMDescDelete();
                      handleTMDescMenuClose();
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <DeleteIcon color="error" />
                      <span>Delete</span>
                    </Stack>
                  </MenuItem>
                </Menu>


                {/* Tables + DFD diagram after 3rd table */}
                {threatTableNames.map((tableTitle, index) => {
                  const isVisible = tableVisibility[tableTitle] !== false;
                  const hasData = threatModellingData?.parsedThreatModelling?.[tableTitle]?.length > 0;

                  return (
                    <React.Fragment key={tableTitle}>
                      {isVisible && hasData && (
                        <Box sx={{ position: "relative", mb: 2 }}>
                          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography variant="body2" fontWeight="bold">{tableTitle}</Typography>
                            <IconButton
                              onClick={(e) => handleTableMenuClick(e, tableTitle)}
                              size="small"
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                            <Menu
                              anchorEl={menuAnchorElMap[tableTitle]}
                              open={Boolean(menuAnchorElMap[tableTitle])}
                              onClose={() => handleTableMenuClose(tableTitle)}
                            >
                              <MenuItem onClick={() => handleTableEdit(tableTitle)}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                  <EditOutlinedIcon color="primary" />
                                  <span>Edit</span>
                                </Stack>
                              </MenuItem>
                              <MenuItem onClick={() => handleTableDelete(tableTitle)}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                  <DeleteIcon color="error" />
                                  <span>Delete</span>
                                </Stack>
                              </MenuItem>
                            </Menu>
                          </Box>

                          <CommonEditableTable
                            title={tableTitle}
                            data={threatModellingData?.parsedThreatModelling?.[tableTitle]}
                            editable={tableEditState[tableTitle] || false}
                            onSave={() => handleTableSave(tableTitle)}
                            onCancel={() => handleTableCancel(tableTitle)}
                          />
                        </Box>
                      )}

                      {/* Render Diagram after 3rd table */}
                      {index === 3 && threatModellingData?.flowchartResponse && (
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" fontWeight="bold">
                            Data Flow Diagram
                          </Typography>

                          <Box sx={{ position: "relative", display: "inline-block", ml: 15, mt: 2 }}>
                            <img
                              src={`data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
                                threatModellingData.flowchartResponse
                              )}`}
                              alt="Flowchart"
                              loading="lazy"
                              style={{
                                maxWidth: "90%",
                                height: "auto",
                                transform: `scale(${zoomLevel})`,
                                border: "1px solid #ccc",
                                borderRadius: "10px",
                                padding: "5px",
                                display: "block",
                              }}
                            />
                            <Box
                              sx={{
                                position: "absolute",
                                bottom: 30,
                                right: 10,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                bgcolor: "rgba(128, 128, 128, 0.8)",
                                borderRadius: 1,
                                p: 0.5,
                              }}
                            >
                              <FileDownloadOutlinedIcon
                                style={{ cursor: "pointer", color: "#ffffff" }}
                                onClick={handleDownloadImage}
                              />
                              <ZoomInIcon
                                onClick={handleOpen}
                                style={{ cursor: "pointer", color: "#ffffff" }}
                              />
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </React.Fragment>
                  );
                })}

              </>
            ) : (
              <Typography variant="body2" color="error">
                Error: No threat modeling data available.
              </Typography>
            )}
          </Box>
        ) : tabValue === 2 ? (
          Object.entries(addReview || {}).map(([field, points], index) => {
            const cleanedKey = field.replace(/^\d+\.\s*/, "");
            const valueArray = Array.isArray(points)
              ? points
              : typeof points === "string"
                ? points.split("\n").map(line => line.trim()).filter(Boolean)
                : [];

            return (
              <Box key={`${index}-${field}`} sx={{ mb: 2, p: 2, backgroundColor: "#7E83880F", borderRadius: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ ml: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                    {cleanedKey}
                  </Typography>
                  <IconButton
                    onClick={(e) =>
                      handleADDReviewMenuClick(
                        e,
                        field,
                        valueArray.join("\n"),
                        index
                      )
                    }
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </Box>

                {valueArray.map((line, i) => (
                  <Typography key={i} variant="body2" sx={{ ml: 1, fontSize: "0.90rem" }}>
                    <li style={{ display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
                      <ArrowRightIcon fontSize="small" />
                      <span>{line}</span>
                    </li>
                  </Typography>
                ))}

                <Menu
                  anchorEl={anchorE2}
                  open={Boolean(anchorE2)}
                  onClose={handleADDReviewMenuClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem
                    onClick={() => {
                      if (selectedADDReview) setOpenADDReviewEdit(true);
                      handleADDReviewMenuClose();
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <EditOutlinedIcon color="primary" />
                      <span>Edit</span>
                    </Stack>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      if (selectedADDReview) {
                        handleADDReviewDelete(selectedADDReview.index, selectedADDReview.field);
                      }
                      handleADDReviewMenuClose();
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <DeleteIcon color="error" />
                      <span>Delete</span>
                    </Stack>
                  </MenuItem>
                </Menu>
              </Box>
            );
          })
        ) :

          // rendering for Tab 4 (Security Test Plan input)
          (<>
            {Object.entries(testPlanResponse).length > 0 ? (
              <SecurityTestPlan securityTestPlanResponse={testPlanResponse} inputData={testPlanInput}/>
            ) : (
              <Box sx={{ padding: 1 }}>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", fontSize: "1 rem", mb: 1 }}
                  >
                    Static Application Security Testing (SAST)
                  </Typography>
                  <TextField
                    fullWidth
                    required
                    label="Number of Lines of Code"
                    placeholder="e.g., 50000"
                    margin="normal"
                    value={linesOfCode}
                    onChange={(e) => {
                      setLinesOfCode(e.target.value);
                      if (showErrors) setShowErrors(false);
                    }}
                    error={showErrors && !linesOfCode.trim()}
                    helperText={
                      showErrors && !linesOfCode.trim()
                        ? "Lines of Code is required"
                        : ""
                    }
                  />
                  <TextField
                    fullWidth
                    label="Programming Languages Used"
                    placeholder="List all programming languages used in your application (e.g., JavaScript, TypeScript, Python, Java, etc.)"
                    margin="normal"
                    multiline
                    rows={3}
                    value={languagesUsed}
                    onChange={(e) => setLanguagesUsed(e.target.value)}
                  />
                  <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">
                      Do you use any third-party libraries or frameworks?
                    </FormLabel>
                    <RadioGroup
                      row
                      value={thirdPartyUsed}
                      onChange={(e) => setThirdPartyUsed(e.target.value)}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", fontSize: "1 rem", mb: 1, mt: 3 }}
                  >
                    Dynamic Application Security Testing (DAST)
                  </Typography>
                  <TextField
                    fullWidth
                    label="Application URL"
                    placeholder="e.g., https://example.com"
                    margin="normal"
                    required
                    value={appURL}
                    onChange={(e) => {
                      setAppURL(e.target.value);
                      setShowErrors(false);
                    }}
                    error={
                      (showErrors && !appURL.trim()) || (touched && urlError)
                    }
                    helperText={
                      showErrors && !appURL.trim()
                        ? "App URL is required"
                        : touched && urlError
                          ? "Please enter a valid URL (e.g., https://example.com)"
                          : ""
                    }
                  />
                  <TextField
                    fullWidth
                    label="Technology Stack Details"
                    placeholder=" (e.g., Frontend: React, Backend: Node.js, Server: nginx, Database: PostgreSQL)"
                    margin="normal"
                    multiline
                    rows={3}
                    value={technologyStack}
                    onChange={(e) => setTechnologyStack(e.target.value)}
                  />
                  <TextField
                    fullWidth
                    label="Number of User roles"
                    placeholder=" (e.g., 3)"
                    margin="normal"
                    value={noOfUsers}
                    onChange={(e) => setNoOfUsers(e.target.value)}
                  />
                  <TextField
                    fullWidth
                    label="User Role Names"
                    placeholder=" (e.g., Admin, User, Manager)"
                    margin="normal"
                    multiline
                    rows={3}
                    value={userRoles}
                    onChange={(e) => setUserRoles(e.target.value)}
                  />
                  <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">
                      Is Multifactor Authentication enabled?
                    </FormLabel>
                    <RadioGroup
                      row
                      value={multiFactorAuth}
                      onChange={(e) => setMultiFactorAuth(e.target.value)}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>

                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", fontSize: "1 rem", mb: 1, mt: 3 }}
                >
                  Additional Information
                </Typography>
                <TextField
                  fullWidth
                  label="Client Name *"
                  placeholder="e.g., Qualizeal"
                  margin="normal"
                  value={clientName}
                  onChange={(e) => {
                    setClientName(e.target.value);
                    if (showErrors) setShowErrors(false);
                  }}
                  error={showErrors && !clientName.trim()}
                  helperText={
                    showErrors && !clientName.trim()
                      ? "Client Name is required"
                      : ""
                  }
                />

                <TextField
                  fullWidth
                  label="Application Name *"
                  placeholder="e.g., QMentisAI"
                  margin="normal"
                  value={appName}
                  onChange={(e) => {
                    setAppName(e.target.value);
                    if (showErrors) setShowErrors(false);
                  }}
                  error={showErrors && !appName.trim()}
                  helperText={
                    showErrors && !appName.trim()
                      ? "Application Name is required"
                      : ""
                  }
                />

                <Box mt={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={isSubmitButtonDisabled}
                    onClick={handleSecurityTestPlan}
                    sx={{ textTransform: "none" }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            )}
          </>
          )}
      </Box>
    );
  };


  //Conditional rendering
  const getAccordionContent = () => {
    switch (tabValue) {
      case 0:
        return renderContent(securityRecommendationsData);
      case 1:
        return renderContent(threatModellingData);
      case 2:
        return renderContent(addReviewData);
      case 3:
        return renderContent(securityTestPlanData);
      default:
        return null;
    }
  };


  //Buttons
  const accordionButtons = [
    {
      label: "Download All",
      startIcon: <FileDownloadOutlinedIcon />,
      variant: "text",
      onClick: handleDownload,
      sx: { textTransform: "none", color: "#49A3FF", float: "left" },
    },
    {
      label: "Next",
      startIcon: <GenerateButton />,
      onClick: handleConstructionPhase,
      variant: "contained",
      sx: {
        textTransform: "none",
        backgroundColor: "#49A3FF",
        color: "#fff",
        marginLeft: "auto",
        float: "right",
      },
    },
  ];


  return (
    <>
      <CommonAccordion
        summary={
          <Typography sx={{ fontSize: "1rem" }}>
            Identified Components
          </Typography>
        }
        details={
          <Box sx={{ mt: 0, pt: 0 }}>
            <Box
              sx={{
                maxHeight: "500px",
                overflowY: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  backgroundColor: "white",
                  px: 1,
                  py: 1,
                  ml: -8,
                }}
              >
                <Tabs
                  value={tabValue}
                  onChange={(_, newValue) => setTabValue(newValue)}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab
                    label={
                      <Typography sx={{ fontSize: "0.90rem" }}>
                        Security Recommendations
                      </Typography>
                    }
                    sx={{
                      flex: 1,
                      textTransform: "none",
                      backgroundColor: "white",
                      borderRadius: "5px",
                    }}
                  />
                  <Tab
                    label={
                      <Typography sx={{ fontSize: "0.90rem" }}>
                        Threat Modelling
                      </Typography>
                    }
                    sx={{
                      flex: 1,
                      textTransform: "none",
                      backgroundColor: "white",
                      borderRadius: "5px",
                      // mr: 1,
                    }}
                  />
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "0.90rem" }}>
                          Architecture Design Review
                        </Typography>
                      </Box>
                    }
                    sx={{
                      flex: 1,
                      textTransform: "none",
                      backgroundColor: "white",
                      borderRadius: "5px",
                    }}
                  />

                  <Tab
                    label={
                      <Typography sx={{ fontSize: "0.90rem" }}>
                        Security Test Plan
                      </Typography>
                    }
                    sx={{ textTransform: "none", backgroundColor: "white", borderRadius: "5px" }}
                  />
                </Tabs>
              </Box>

              <Box
                ref={scrollRef}
                sx={{
                  maxHeight: 400,
                  overflowY: "auto",
                  p: 1,
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "-ms-overflow-style": "none",
                  "scrollbar-width": "none",
                }}
              >
                {getAccordionContent()}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 2,
                  marginBottom: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Tooltip title="Like" arrow>
                    <Box
                      onClick={() => handleThumbClick("like")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2,
                        "&:hover": { color: "#49A3FF" },
                      }}
                    >
                      {activeThumb === "like" ? (
                        <ThumbUpIcon sx={{ fontSize: "24px" }} />
                      ) : (
                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} />
                      )}
                    </Box>
                  </Tooltip>
                  <Tooltip title="Dislike" arrow>
                    <Box
                      onClick={() => handleThumbClick("dislike")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2,
                        "&:hover": { color: "#FF4842" },
                      }}
                    >
                      {activeThumb === "dislike" ? (
                        <ThumbDownIcon sx={{ fontSize: "24px" }} />
                      ) : (
                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} />
                      )}
                    </Box>
                  </Tooltip>

                  {tabValue === 0 ? (
                    <CommonCopy contentToCopy={securityRecommendationsData} />
                  ) : tabValue === 1 ? (
                    <CommonCopy contentToCopy={formatThreatModellingDataReadable(threatModelToDownload)} />
                  ) : (
                    <CommonCopy contentToCopy={addReview} />
                  )}
                </Box>

                <Button
                  variant="text"
                  onClick={handleEachTabDownload}
                  startIcon={<FileDownloadOutlinedIcon />}
                  sx={{
                    textTransform: "none",
                    color: "#42a5f5",
                    mr: 4,
                  }}
                >
                  Download
                </Button>
              </Box>
            </Box>
          </Box>
        }
        buttons={accordionButtons}
        defaultExpanded={true}
        fullScreenMode={true}
      />
      <CommonDownload
        open={downloadETDOpen}
        onClose={() => setDownloadETDOpen(false)}
        serviceName={downloadEachTabData?.serviceName}
        serviceResponse={downloadEachTabData?.serviceResponse}
        wordData={downloadEachTabData?.wordData}
        documents={["docx", "pdf"]}
      />

      <CommonDownload
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
        serviceName="Design Phase Document"
        serviceResponse={[
          {
            heading: "Security Recommendations",
            type: "text",
            data: hrForPdf
          },
          ...secRecommendationsToDownload,
          {
            heading: "Threat Modelling",
            type: "text",
            data: hrForPdf
          },
          ...threatModelToDownload,
          {
            heading: "Data Flow Diagram",
            type: "image",
            data: pngData
          },
          {
            heading: "Architecture Design Review",
            type: "text",
            data: hrForPdf
          },
          ...addReviewToDownload
        ]}
        wordData={[
          {
            heading: "Security Recommendations",
            type: "text",
            data: hrForDoc
          },
          ...secRecommendationsToDownload,
          {
            heading: "Threat Modelling",
            type: "text",
            data: hrForDoc
          },
          ...threatModelToDownload,
          {
            heading: "Data Flow Diagram",
            type: "image",
            data: pngData?.replace(/^data:image\/png;base64,/, "") || ""

          },
          {
            heading: "Architecture Design Review",
            type: "text",
            data: hrForDoc
          },
          ...addReviewToDownload
        ]}
        documents={["docx", "pdf"]}
      />

      <CommonEditDialog
        open={openSecRecomEdit}
        onClose={() => setOpenSecRecomEdit(false)}
        onSave={handleSecRecomSave}
        title="Edit Security Recommendations"
        initialData={selectedSecRecom}
        fields={[
          { label: "Module", field: "title" },
          {
            label: "Security Recommendations",
            field: "recommendations",
            multiline: true,
            rows: 6,
          },
        ]}
      />

      <CommonEditDialog
        open={openADDReviewEdit}
        onClose={() => setOpenADDReviewEdit(false)}
        onSave={handleADDReviewSave}
        initialData={{ value: selectedADDReview?.value || "" }}
        fields={[
          { label: selectedADDReview?.field || "", field: "value", multiline: true, rows: 6 }
        ]}
      />

      <CommonEditDialog
        open={openTMDescEdit}
        onClose={() => setOpenTMDescEdit(false)}
        onSave={(updated) => handleTMDescSave(updated.recommendations)}
        title="Edit Threat Modelling Description"
        initialData={{
          recommendations: transformTMDescForEdit(threatModellingData?.parsedThreatModelling?.["Description"] || ""),
        }}

        fields={[
          {
            label: "Threat Modelling Description",
            field: "recommendations",
            multiline: true,
            rows: 6,
          },
        ]}
      />

      <Modal
        open={isModalOpen}
        onClose={handleClose}
        aria-labelledby="zoomed-modal-title"
        aria-describedby="zoomed-modal-description"
        closeAfterTransition
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90vw",
            height: "90vh",
            bgcolor: "#fff",
            border: "none",
            boxShadow: 24,
            borderRadius: 2,
            p: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#000",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          <img
            src={`data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
              threatModellingData.flowchartResponse
            )}`}
            alt="Flowchart"
            loading="lazy"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              border: "none",
              borderRadius: "8px",
            }}
          />
        </Box>
      </Modal>

    </>
  );
};

export default SecondFunctionalModules;
